import { Component } from '@angular/core';

@Component({
  selector: 'app-safe-menu',
  templateUrl: './safe-menu.component.html',
  styleUrls: ['./safe-menu.component.scss']
})
export class SafeMenuComponent {

}
